import styled from '@emotion/styled'

export const AuditTrailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > button {
    width: fit-content;
    margin: 0 auto;
  }
`
